/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { ProductsApiService, City, RESTClientConfig } from 'rest-client';

import { languages } from '@app/i18n/lang-loader';
import { FormVersionConfig } from '@app/modules/shared/models/form-version-config.model';
import { SetCitiesAction } from '@core/states/booking-state/booking.actions';
import { LANG_STORAGE, LANG_STORAGE_REGEX } from '@shared/const/cookies.consts';
import { FORM_VERSIONS } from '@shared/const/form_version.consts';
@Injectable()
export class AppConfigService {
  constructor(
    private productsApiService: ProductsApiService,
    private store: Store,
    private translateService: TranslateService,
    private restClientConfig: RESTClientConfig
  ) {}

  loadCities(lang: string): Promise<void> {
    return this.productsApiService
      .listCitiesAndProducts(lang)
      .then((cities: City[]) => {
        this.store.dispatch(new SetCitiesAction(cities));
      });
  }

  initializeLangs(): void {
    this.translateService.addLangs(Object.values(languages));
    this.translateService.setDefaultLang(languages.es);

    const browserCultureLang = this.translateService.getBrowserCultureLang();
    if (
      localStorage.getItem(LANG_STORAGE) &&
      LANG_STORAGE_REGEX.exec(localStorage.getItem(LANG_STORAGE))
    ) {
      this.setLang(localStorage.getItem(LANG_STORAGE));
    } else if (LANG_STORAGE_REGEX.exec(browserCultureLang)) {
      this.setLang(browserCultureLang);
    } else {
      this.setLang(languages.es);
    }
  }

  setLang(language: string): void {
    let lang = language;
    if (language.includes('_')) {
      lang = language.split('_')[0];
    } else if (language.includes('-')) {
      lang = language.split('-')[0];
    }
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    this.restClientConfig.setLang(lang);
  }

  loadFormVersionConfig(): FormVersionConfig {
    const formVersion = localStorage.getItem('form_version');
    const formVersionConfig: FormVersionConfig = {
      formVersion: 1,
      navTabsConfiguration: 'NAV_TABS_CONFIG',
      servicesPageTemplateUrl: './services-page.component.html',
      productStepNextRoute: '/services',
      visibilityBlockConfirmation: true,
      visibilityCTAServicesBlock: false,
    };

    switch (formVersion) {
      case null || undefined:
        this.setFormVersionStorage();
        return formVersionConfig;
      case '1':
        return formVersionConfig;
      case '2':
        formVersionConfig.formVersion = +formVersion;
        formVersionConfig.navTabsConfiguration =
          'NAV_TABS_CONFIG_FORMVERSION_2';
        formVersionConfig.productStepNextRoute = '/traveler-data';
        formVersionConfig.visibilityBlockConfirmation = false;
        formVersionConfig.visibilityCTAServicesBlock = true;
        return formVersionConfig;
      case '3':
        formVersionConfig.servicesPageTemplateUrl =
          './services-page-B.component.html';
        return formVersionConfig;
    }

    return formVersionConfig;
  }

  getFormVersionStorage(): string {
    const formVersion = localStorage.getItem('form_version');
    if (formVersion) {
      return formVersion;
    } else {
      this.setFormVersionStorage();
      return localStorage.getItem('form_version');
    }
  }

  setFormVersionStorage(formVersion?: string): void {
    if (formVersion) {
      localStorage.setItem('form_version', formVersion.toString());
    } else {
      const version = this.getRandomFormVersion();
      localStorage.setItem('form_version', version.toString());
    }
  }

  getRandomFormVersion(): number {
    return FORM_VERSIONS[Math.floor(Math.random() * FORM_VERSIONS.length)];
  }
}

export function loadInitialData(
  appConfigService: AppConfigService,
  translateService: TranslateService
): () => Promise<void> {
  appConfigService.initializeLangs();
  return (): Promise<void> =>
    appConfigService.loadCities(translateService.getDefaultLang());
}
